module.exports = __webpack_public_path__ + "img/Dog.bd8e73a9.png";